
import { computed, defineComponent, PropType, toRefs, reactive } from 'vue'
import { IButtonOptions } from '@/typings/common'

interface IButtonStyle {
  width: string
  height: string
  color: string
  text: string
  background: string
  lineHeight: string
}

export default defineComponent({
  props: {
    btnOption: {
      type: Object as PropType<IButtonOptions>,
      default(this: void) {
        return reactive({
          width: 200,
          height: 42,
          background: '#07C063',
          text: 'button',
          color: '#fff'
        })
      }
    }
  },
  setup(props) {
    const { btnOption } = toRefs(props)
    const { width, height, background, text, color } = toRefs<IButtonOptions>(
      btnOption.value
    )
    const styles = computed(() => {
      return reactive<IButtonStyle>({
        width: width.value + 'px',
        height: height.value + 'px',
        background: background.value,
        color: color.value,
        text: text.value,
        lineHeight: height.value + 'px'
      })
    })
    return {
      styles
    }
  }
})
